import { ClientEntity } from 'entities/Client';
import { ClientUniquenessStore } from 'stores/global/ClientUniquenessStore';

import { ClientEditFormStore } from '../../ClientEditFormStore';

export type CreateClientStoreOptions = {
  onCreated: () => void;
  onNextStep: () => void | Promise<void>;
  checkUniqueClientStore?: ClientUniquenessStore;
};

export class CreateClientStore extends ClientEditFormStore {
  private readonly _onNextStep: CreateClientStoreOptions['onNextStep'];

  createdClient?: ClientEntity;

  constructor({ onCreated, onNextStep, checkUniqueClientStore }: CreateClientStoreOptions) {
    super({
      onSuccess: ({ isCreated, createdClient }) => {
        if (isCreated && createdClient) {
          this.createdClient = createdClient;
          onCreated();
        }
      },
      checkUniqueClientStore,
    });

    this._onNextStep = onNextStep;
  }

  nextStep = async () => {
    if (!this.validateFields()) {
      return;
    }

    await this._onNextStep();
  };
}
